import React, { Component } from 'react';
import dayjs from 'dayjs';

import { LubesCategoryList, ProductList } from '@C/Lubes/_utils/';
import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import { PaymentMethodInfo, StaffList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Bill No',
    key: 'payment_for',
    formatter(props) {
      return <>{props.bill_number}</>;
    },
  },
  {
    name: 'Product',
    key: 'payment_for',
    formatter(props) {
      return <>{props.name}</>;
    },
  },
  {
    name: 'Qty',
    key: 'payment_for',
    formatter(props) {
      return <>{props.quantity}</>;
    },
  },
  {
    name: 'Discount',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.discount)}</>;
    },
  },
  {
    name: 'Amount (Excl Tax)',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.balance)}</>;
    },
  },
  {
    name: 'Amount (Inc Tax)',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.after_tax)}</>;
    },
  },
  {
    name: 'Payment mode',
    key: 'payment_method',
    type: 'payment',
    formatter(props) {
      return (
        <>
          <PaymentMethodInfo
            source={props.source}
            method={props.payment_method}
            bank={props.bank}
            wallet={props.other_wallet}
          />
        </>
      );
    },
  },
  {
    name: 'Staff',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
];

class LubesSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      product_uuid: '',
      lube_category: '',
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getLubesSalesReport();
    });
  };

  componentDidMount() {
    this.getLubesSalesReport();
  }

  handleProductChange = (e, i) => {
    this.setState({ product_uuid: e?.value || '' });
  };

  handleCategoryChange = (e) => {
    this.setState({ lube_category: e.value });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  getLubesSalesReport = () => {
    services
      .getLubesSalesReport(this.state)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getLubesSalesReport();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  resetFilter = () => {
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_uuid: '',
        lube_category: '',
        loading: true,
        limit: 20,
        offset: 1,
      },
      function () {
        this.getLubesSalesReport();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getLubesSalesReport();
    });
  };

  render() {
    const { slipList } = this.state;
    const exportOptions = {
      fileName: `Products Sales - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Products Sales Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format(
        'D MMM YY',
      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportTotal: `Total amount -  ${
        slipList.reduce((a, b) => a + (b['after_tax'] || 0), 0).toFixed(2) || 0
      }`,
      reportQuantity: `Total discount -  ${
        slipList
          .reduce((a, b) => a + (b['payment_for']['discount'] || 0), 0)
          .toFixed(2) || 0
      }`,
      reportSales: '',
      reportTesting: '',
      reportBowser: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
    };
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Products Sales Report ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total amount: </span>
                  <span>
                    {formatCurrency(
                      slipList.reduce((a, b) => a + (b['after_tax'] || 0), 0) ||
                        0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total discount: </span>
                  <span>
                    {formatCurrency(
                      slipList.reduce(
                        (a, b) => a + (b['payment_for']['discount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>

              <div className="filter-group">
                <label>Staff:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <ProductList
                  handleDropdownChange={this.handleProductChange}
                  value={this.state.product_uuid}
                  isShowDeleted={true}
                />
              </div>
              <div className="filter-group">
                <label>Category:</label>
                <LubesCategoryList
                  handleDropdownChange={this.handleCategoryChange}
                  value={this.state.lube_category}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={slipList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: `Products Sales - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Products Sales Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        slipList
                          .reduce((a, b) => a + (b['after_tax'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: `Total discount -  ${
                        slipList
                          .reduce(
                            (a, b) => a + (b['payment_for']['discount'] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { LubesSales };
